export var ADJUSTMENT_CATEGORIES = {
  FINANCE: 'FINANCE',
  OTHER: 'OTHER'
};
export var NOTE_TYPES = {
  CREDIT: '1006'
};
export var MIN_NOTE_AMOUNT = 0.01;
export var MAX_DESCR_LENGTH = 200;
export var INVOICE_START_DATE_DURATION = 6;
export var INVOICE = 'Invoice';
export var WITHHELD_TAX_EXTERNAL_REF = {
  Key: 'external_reference',
  Value: 'WITHHOLDING_TAX_CERTIFICATE'
};